export default __webpack_public_path__ + "static/media/other.a02ea9ae.svg";